import getActiveCart from '../activeCart/useActiveCart';

const useGetActiveCartObject = (skip = false) => {
    const { activeCart } = getActiveCart(skip);

    return activeCart;
};

export default useGetActiveCartObject;
